module.exports = "static/assets/f108ac9d733ce5d45cdea3b7828e8658.woff2";